"use strict";

var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ClientMetricsLogger = void 0;
var InteractionMetrics_1 = require("./InteractionMetrics");
var PerformanceMetrics_1 = require("./PerformanceMetrics");
var SystemEvent_1 = require("./SystemEvent");
var ClientMetricsLogger = /** @class */function () {
  function ClientMetricsLogger(clientLogger) {
    this.clientLogger = clientLogger;
    if (!ClientMetricsLogger.pm || !ClientMetricsLogger.im) {
      this.initMetrics();
    }
  }
  ClientMetricsLogger.prototype.initLogger = function (metadata) {
    var client = metadata.client,
      lob = metadata.lob,
      locale = metadata.locale,
      siteId = metadata.siteId,
      personalize = metadata.personalize,
      inputId = metadata.inputId,
      getDevice = metadata.getDevice,
      variants = metadata.variants;
    ClientMetricsLogger.metadata = {
      client: client,
      lob: lob,
      locale: locale,
      siteId: siteId,
      personalize: personalize,
      inputId: inputId,
      getDevice: getDevice,
      variants: variants
    };
  };
  ClientMetricsLogger.prototype.logTypeaheadOpen = function (prefill) {
    ClientMetricsLogger.im.logTypeaheadOpen(prefill);
  };
  ClientMetricsLogger.prototype.logTypeaheadRequest = function (query) {
    ClientMetricsLogger.im.logTypeaheadRequest(query);
    ClientMetricsLogger.pm.logTypeaheadRequest(query);
  };
  ClientMetricsLogger.prototype.logResponse = function (response) {
    ClientMetricsLogger.pm.logResponse(response);
  };
  ClientMetricsLogger.prototype.logTypeaheadResponse = function (response) {
    ClientMetricsLogger.pm.logTypeaheadResponse(response);
  };
  ClientMetricsLogger.prototype.logSuggestionShown = function (response) {
    ClientMetricsLogger.pm.logSuggestionShown(response.q);
    ClientMetricsLogger.im.logSuggestionShown(response);
  };
  ClientMetricsLogger.prototype.logSuggestionSelected = function (selected, taEventMessage) {
    ClientMetricsLogger.im.logTypeaheadSelection(selected);
    ClientMetricsLogger.im.logTypeaheadEventMessage(taEventMessage);
  };
  ClientMetricsLogger.prototype.logError = function (statusCode, statusText) {
    ClientMetricsLogger.pm.logError(statusCode, statusText);
  };
  ClientMetricsLogger.prototype.logTypeaheadClientMetrics = function () {
    if (this.clientLogger && "function" === typeof this.clientLogger.getLoggerWithIdentifier) {
      var logger = this.clientLogger.getLoggerWithIdentifier("uitk-react-typeahead");
      if (logger && typeof logger.logEvent === "function") {
        logger.logEvent(new SystemEvent_1.SystemEvent(SystemEvent_1.SystemEventLevel.INFO, "TypeaheadInteraction"), __assign(__assign({}, ClientMetricsLogger.im.getMetrics(ClientMetricsLogger.metadata)), ClientMetricsLogger.pm.getMetrics()));
      }
    }
    this.initMetrics();
  };
  ClientMetricsLogger.prototype.initMetrics = function () {
    ClientMetricsLogger.im = new InteractionMetrics_1.InteractionMetrics(); // clear interaction logs
    ClientMetricsLogger.pm = new PerformanceMetrics_1.PerformanceMetrics(); // clear performance logs
  };
  return ClientMetricsLogger;
}();
exports.ClientMetricsLogger = ClientMetricsLogger;